if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
document.addEventListener('click', function (e) {
  const pill = e.target.closest('.variant-pill');
  if (!pill) return;

  const wrapper = pill.closest('.card-variants');
  if (!wrapper) return;

  // 👉 SI SOLO HAY 1 VARIANTE, NO HACER NADA
  const pills = wrapper.querySelectorAll('.variant-pill');
  if (pills.length === 1) return;

  const form = pill.closest('form');
  if (!form) return;
  // activar estado visual
  wrapper.querySelectorAll('.variant-pill').forEach(btn => {
    btn.classList.remove('active');
  });
  pill.classList.add('active');

  // cambiar variante seleccionada
  const variantId = pill.dataset.variantId;
  const input = form.querySelector('.product-variant-id');
  if (input) {
    input.value = variantId;
  }
});
document.addEventListener('click', function (e) {
  const pill = e.target.closest('.variant-pill');
  if (!pill) return;

  const newPrice = pill.dataset.price;
  if (!newPrice) return;

  const card = pill.closest('.card-wrapper, .product-card-wrapper');
  if (!card) return;

  const priceWrapper = card.querySelector('[data-card-price]');
  if (!priceWrapper) return;

  priceWrapper.innerHTML = newPrice;
});
document.addEventListener('click', function (e) {
  const pill = e.target.closest('.variant-pill');
  if (!pill) return;

  const imageUrl = pill.dataset.image;
  if (!imageUrl) return;

  const card = pill.closest('.card-wrapper');
  if (!card) return;

  const img = card.querySelector('.card__media img');
  if (!img) return;

  img.src = imageUrl;
  img.srcset = imageUrl;
});
document.querySelectorAll('.card-variants').forEach(wrapper => {
  const active = wrapper.querySelector('.variant-pill.active');
  if (!active) {
    const firstAvailable = wrapper.querySelector('.variant-pill:not(.disabled)');
    if (firstAvailable) firstAvailable.click();
  }
});
document.querySelectorAll('.card-variants').forEach(wrapper => {
  const pills = wrapper.querySelectorAll('.variant-pill:not(.disabled)');
  
  if (pills.length === 1) {
    pills[0].classList.add('active');
    pills[0].click();
  }
});
document.querySelectorAll('.card-variants').forEach(wrapper => {
  const availablePills = wrapper.querySelectorAll('.variant-pill:not(.disabled)');

  if (availablePills.length === 1) {
    const pill = availablePills[0];
    pill.classList.add('active');

    const card = pill.closest('.card-wrapper, .product-card-wrapper');
    if (!card) return;

    // 👉 actualizar precio
    const priceWrapper = card.querySelector('[data-card-price]');
    if (priceWrapper && pill.dataset.price) {
      priceWrapper.innerHTML = pill.dataset.price;
    }

    // 👉 actualizar imagen
    const img = card.querySelector('.card__media img');
    if (img && pill.dataset.image) {
      img.src = pill.dataset.image;
      img.srcset = pill.dataset.image;
    }

    // 👉 actualizar input hidden
    const form = pill.closest('form');
    if (form) {
      const input = form.querySelector('.product-variant-id');
      if (input) {
        input.value = pill.dataset.variantId;
      }
    }
  }
});

